module.exports = __webpack_public_path__ + "static/media/filled_bar_postlapAERO_hand_tall.db4a86f0.svg";